<template>
  <a
    :class="disabled? $style.refreshAnchorDisabled : $style.refreshAnchor"
    :href="disabled ? '' : href"
    :rel="rel"
    :target="target"
    @click.prevent="handleClick"
  >
    <svg width="15" height="14" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="!disabled" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.74 11.397l.471.11a.807.807 0 00.978-.638.872.872 0 00-.65-1.015L2.22 9.318a.806.806 0 00-.955.548L.63 11.877a.873.873 0 00.539 1.079.807.807 0 001.044-.522l.07-.22c.97 1.32 2.274 2.13 3.332 2.502a6.665 6.665 0 005.12-.33c1.874-.937 2.937-2.624 3.355-3.947a.873.873 0 00-.54-1.078.806.806 0 00-1.043.521c-.312.988-1.127 2.275-2.534 2.978a5.041 5.041 0 01-3.853.256c-.742-.261-1.663-.825-2.381-1.719zm6.47-5.218a.872.872 0 01-.65-1.015.807.807 0 01.978-.637l.471.109c-.718-.894-1.638-1.457-2.38-1.719a5.04 5.04 0 00-3.854.256c-1.407.703-2.222 1.99-2.533 2.978a.807.807 0 01-1.044.521.873.873 0 01-.54-1.078c.418-1.323 1.481-3.01 3.355-3.946a6.665 6.665 0 015.12-.331c1.058.372 2.362 1.182 3.333 2.502l.07-.22a.806.806 0 011.043-.522.873.873 0 01.54 1.079l-.635 2.012a.806.806 0 01-.955.547L10.21 6.18z" fill="#006CAC"/></svg>
    <svg width="15" height="14" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" v-else="" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.74 11.397l.471.11a.807.807 0 00.978-.638.872.872 0 00-.65-1.015L2.22 9.318a.806.806 0 00-.955.548L.63 11.877a.873.873 0 00.539 1.079.807.807 0 001.044-.522l.07-.22c.97 1.32 2.274 2.13 3.332 2.502a6.665 6.665 0 005.12-.33c1.874-.937 2.937-2.624 3.355-3.947a.873.873 0 00-.54-1.078.806.806 0 00-1.043.521c-.312.988-1.127 2.275-2.534 2.978a5.041 5.041 0 01-3.853.256c-.742-.261-1.663-.825-2.381-1.719zm6.47-5.218a.872.872 0 01-.65-1.015.807.807 0 01.978-.637l.471.109c-.718-.894-1.638-1.457-2.38-1.719a5.04 5.04 0 00-3.854.256c-1.407.703-2.222 1.99-2.533 2.978a.807.807 0 01-1.044.521.873.873 0 01-.54-1.078c.418-1.323 1.481-3.01 3.355-3.946a6.665 6.665 0 015.12-.331c1.058.372 2.362 1.182 3.333 2.502l.07-.22a.806.806 0 011.043-.522.873.873 0 01.54 1.079l-.635 2.012a.806.806 0 01-.955.547L10.21 6.18z" fill="#92999E"/></svg>
    <span :class="$style.vAlignTop">{{ refreshButtonText }}</span>
  </a>
</template>
<script>

export default {
  name: 'RefreshButton',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      required: true,
    },
    refreshButtonText: {
      type: String,
      default: 'Refresh',
    },
    rel: {
      type: String,
      default: 'noopener noreferrer',
    },
    target: {
      type: String,
      default: '_blank',
    },
  },

  methods: {
    handleClick() {
      if (this.disabled) {
        return;
      }
      this.$emit('click');
    },
  },
};
</script>
<style module scoped>
@value (jcGrey400) from '~css/brand-colors.css';

.vAlignTop {
  vertical-align: top;
}

.refreshAnchor {
  cursor: pointer;
  margin-bottom: 0.3846rem;
}

.refreshAnchorDisabled {
  color: jcGrey400;
  cursor: not-allowed;
  margin-bottom: 0.3846rem;
}

.refreshAnchorDisabled:focus,
.refreshAnchorDisabled:hover {
  color: jcGrey400;
  text-decoration: none;
}

</style>
